import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { templateKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useMarkTemplates = (parent, enabled = true) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryKey: templateKeys.rows(parent),
        queryFn: () => axios.get(markUrl('mark-templates/list/'), {
            ...additional,
            params: parent
        }),
        staleTime: 30_000,
        enabled
    });
};
export default useMarkTemplates;
